import React from 'react';
import Modal from "./Modal";


function ErrorModal(props) {
    return (
        <Modal show={props.show}
            onClose={props.onClose}
            title={props.title}>
            <div className="flex grow flex-col justify-center">
                <div className="my-8 text-primary-dark text-2xl text-center">
                    <p>
                        {props.message}
                    </p>
                </div>
            </div>
        </Modal>
    );
}

export default ErrorModal;